import { Box, Tabs, Tab as MuiTab } from "@mui/material";
import { useState } from "react";
import SectionPaper from "../../widgets/SectionPaper";
import PageTitle from "../../widgets/PageTitle";
import DataGrid from "./DataGrid";

export type Tab = "sources" | "tags";

const PricingManagement = () => {
  const [selectedTab, setSelectedTab] = useState<Tab>("sources");

  // One card for the page, tabs switching the table's content — mirrors colour settings.
  return (
    <SectionPaper sx={{ width: "100%" }}>
      <PageTitle />
      <Tabs
        value={selectedTab}
        onChange={(_, v) => setSelectedTab(v as Tab)}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <MuiTab value="sources" label="Sources" />
        <MuiTab value="tags" label="Tags" />
      </Tabs>
      <Box sx={{ pt: 2 }}>
        <DataGrid selectedTab={selectedTab} />
      </Box>
    </SectionPaper>
  );
};

export default PricingManagement;
